import { AlternativeImage, ImageCheckType } from "Explore/Config/ImageType";
export const checkImageUrl = (url, setImage, type) => {
  var image = new Image();
  image.onload = function () {
    if (this.width > 0) {
      setImage(url);
    }
  };
  image.onerror = function () {
    if (type == ImageCheckType.INSTITUTION_LOGO) {
      setImage(AlternativeImage.INSTITUTION_LOGO);
    } else if (type == ImageCheckType.INSTITUTION_SEAL) {
      setImage(AlternativeImage.INSTITUTION_SEAL);
    } else if (type == ImageCheckType.FACULTY_AVATAR) {
      setImage(AlternativeImage.FACULTY_AVATAR);
    } else if (type == ImageCheckType.INSTITUTION_LANDSCAPE) {
      setImage(null);
    }
  };
  image.src = url;
};
